import { render, staticRenderFns } from "./MyMessages.vue?vue&type=template&id=4803b593&"
import script from "./MyMessages.vue?vue&type=script&lang=js&"
export * from "./MyMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports